import './styles.scss'

import { Divider } from 'antd'

import { useAppSelector } from '@/store/hook'
import { selectCheckoutSetting } from '@/store/selectors/cartSelector'
import useDeviceDetect from '@/hooks/useDeviceDetect'

import ButtonsWrapperComponent from '../components/ButtonsWrapper'
import PaymentMethod from './PaymentMethod'
import ReferenceNumber from './ReferenceNumber'
import ShippingNotes from './ShippingNotes'
import ShippingOptions from './ShippingOptions'

interface StepTwoComponentProps {
  form: {
    validateFields?: (...args: unknown[]) => unknown
  }
  tab?: number
  setTabHandler?: (...args: unknown[]) => unknown
}

const StepTwoComponent = (props: StepTwoComponentProps) => {
  const { tab = 1, setTabHandler, form } = props
  const { isMobile } = useDeviceDetect()
  const checkoutSettings = useAppSelector(selectCheckoutSetting)

  return (
    <div className="step-two__wrapper fw-container">
      <ReferenceNumber />
      <Divider className="checkout-step1__divider" />
      <PaymentMethod />
      {!isMobile && <Divider className="checkout-step1__divider" />}
      <ShippingOptions />
      {checkoutSettings?.shippingNotes && (
        <>
          <Divider className="checkout-step1__divider" />
          <ShippingNotes form={form} />
        </>
      )}

      <div className="checkout__bottom-space" />
      <div className="fw-container">
        <ButtonsWrapperComponent
          form={form}
          setTabHandler={setTabHandler}
          tab={tab}
        />
      </div>
    </div>
  )
}

export default StepTwoComponent
